import { useContext } from "react";
import { RouteContext } from "../context/RouteContext";

export const useRoute = () => {
  const context = useContext(RouteContext);

  if (context === undefined) {
    throw new Error();
  }
  return context;
};
